/** School registered with a partner offer awaiting IFIP finance confirmation. */
export function schoolHasUnsettledExternalPayment(school) {
  return school?.paymentStatus === "awaiting_external_settlement"
    || school?.renewalSettlementStatus === "awaiting_external_settlement";
}

export function buildExternalSettlementWarning(schoolName, actionLabel) {
  const name = schoolName || "this school";
  const action = actionLabel ? ` (${actionLabel})` : "";
  return (
    `Partner offer registration: external payment for ${name} has not been confirmed by IFIP finance${action}. ` +
    "You may continue, but fees may still be outstanding."
  );
}

/** Returns true if the user chose to proceed. */
export function confirmProceedDespiteUnsettledPayment(message) {
  return window.confirm(`${message}\n\nProceed anyway?`);
}

/** Registry / directory: paid schools plus active partner-offer schools awaiting settlement. */
export function schoolVisibleInPaidRegistry(school) {
  const ps = school?.paymentStatus;
  return ps === "paid" || ps === "awaiting_external_settlement";
}

export function canConfirmExternalPayment(permissions) {
  return !!permissions?.canManagePayments;
}
